import React from "react";
import { Link, LinkProps } from "react-router-dom";

export type Props = LinkProps & React.RefAttributes<HTMLAnchorElement> & { condition: any };

export default function ConditionalLink(props: Props) {
  const { children, condition } = props;
  return !!condition ? <Link {...props}>{children}</Link> : <>{children}</>;
}
